export default "__VITE_ASSET__BfWOFfr6__"